jQuery(document).ready(function () {
    const lightEffect = document.querySelector('.light-effect');

    window.addEventListener('scroll', () => {
        if(lightEffect.getBoundingClientRect().top < window.innerHeight * -.2) {
            lightEffect.classList.add('light-effect--active');
        } else {
            lightEffect.classList.remove('light-effect--active');
        }
    });
})